import { useEffect, useState } from 'react';
export var useReadyExperiments = function (experiments) {
    var _a = useState(!experiments.pending()), ready = _a[0], setReady = _a[1];
    useEffect(function () {
        var mounted = true;
        if (!ready) {
            void experiments
                .ready()
                .then(function () {
                if (mounted) {
                    setReady(true);
                }
            })
                .catch(function () { });
        }
        return function () {
            mounted = false;
        };
    }, [ready, experiments]);
    return {
        ready: ready,
        promise: experiments.ready(),
        experimentsInstance: experiments,
    };
};
//# sourceMappingURL=useReadyExperiments.js.map